<template>
  <div class="content">
    <div class="md-layout">
      <div class="md-layout-item md-medium-size-100 md-size-66">
        <edit-profile-form
          header-color="green"
          v-on:childToParent="updateUserData"
          v-bind:user="user"
        >
        </edit-profile-form>
      </div>
      <div class="md-layout-item md-medium-size-100 md-size-33">
        <user-card button-color="success" v-bind:userDisplay="user"> </user-card>
      </div>
    </div>
  </div>
</template>

<script>
import { EditProfileForm, UserCard } from "@/pages";
import api from "@/api";
import store from "@/store";
import { mapState } from 'vuex';
import SigPad from "@/pages/Dashboard/ProjectPages/Components/SigPad.vue";


// only details we need for this page
//Name, Email, Cell, Company, Company Position (job), License
export default {
  components: {
    EditProfileForm,
    UserCard,
    SigPad
  },
  data() {
    return {
      user: {},
      orientation: {
        id: '',
        terms: '',
        signature: ''
      },
      alreadySigned: '',
      downloadClicked: false,
    };
  },
  created() {
    const userId = this.$store.state.user.id;
    console.log()
    api.getUserData(userId).then(response => {
      // console.log(response.data);
      this.user = response.data.user;
      this.user.company_name = response.data.company.company_name;
      console.log(this.user);
      // this.user.signature
      if (this.user.orientation_signature.length){
        this.alreadySigned = true;
        this.downloadClicked = true;
      } else {
        this.alreadySigned = false;
        this.downloadClicked = false;
      }
    })
    // this.$store.dispatch("getUserData");
  },
  computed: mapState(['userData']),
  watch:{
    userData(newValue, oldValue) {
      console.log(`Old Value: ${oldValue} to New Value: ${newValue}`);
    }
  },
  methods: {
    updateUserData() {
      this.$store.dispatch("updateUserData", this.user).then(() => {
        this.alreadySigned = true;
        this.notifyVue("Your information has been updated");
      })
    },
    notifyVue(message) {
      this.$notify({
        timeout: 2500,
        message: message,
        icon: "done_all",
        horizontalAlign: "left",
        verticalAlign: "top",
        type: "success"
      });
    },
    saveSig(data) {
      // console.log('savesig')
      // console.log(data)
      this.orientation.signature = data;
      this.user.orientation_signature = data;
      this.updateUserData();
    }
  }
};
</script>
<style lang="scss">
.text-right {
  display: flex;
}
</style>
